var $itag={'scodeId':'CORPCV','PageId':'21923'};
window.digitalData={
    page:{
        attributes:{
            autotrack: false
        },
        pageInfo:{
            pageName:'post-login',
            country:getDocValue('adobeCountryCode'),
            language:getDocValue('adobeLanguageCode')
        },
        category: {
            businessUnit:'Ser', // TODO: Change this once we hear from Mariya
            primaryCategory:'AtWorkRecon', // App name
            subCategory1:'Company:'+getDocValue('adobeCompanyId') // Company Id
        }
    },
    user:{},
    event:[]
};

function getDocValue(id){
    if( document.getElementById(id) ) {
        return document.getElementById(id).value;
    }
    return '';
}


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/adobe.js
// module id = 421
// module chunks = 0